import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
import { Link, withRouter } from "react-router-dom";
// @ts-ignore
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { extendMoment } from 'moment-range';
import regions from "../../components/Global/regions";
import 'moment/locale/ru';
var Moment = require("moment");
var moment = extendMoment(Moment);
moment.locale('ru');
var qs = require("qs");
var Suggestions = /** @class */ (function (_super) {
    tslib_1.__extends(Suggestions, _super);
    function Suggestions(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            suggestions: [],
            page: _this.props.history.location.search.split('=')[1] ? Number(_this.props.history.location.search.split('=')[1]) - 1 : 0,
            pageSize: 20,
            search_query: '',
            regions: '',
            status: '',
            tids: [],
            stids: [],
            dateFrom: moment().add(-1, 'year'),
            dateTo: moment(),
            regionList: regions.regions,
            rolesList: [{ name: 'Житель ДВ', value: 'user_dv' }, { name: 'Житель другой части РФ', value: 'user_rf' }, { name: 'Эксперт ДВ', value: 'expert_dv' }, { name: 'Эксперт другой части РФ', value: 'expert_rf' }],
            statusList: [{ name: "На модерации", value: "new" }, { name: "Опубликовано", value: "approved" }, { name: "Отклонено", value: "declined" }, { name: "Снято с публикации автором", value: "userhold" }],
            themeList: [],
            subthemeList: [],
            filterRegions: [],
            filterSubthemes: [],
            filterThemes: [],
            filterRoles: [],
            report: false,
            filterStatuses: [],
        };
        return _this;
    }
    Suggestions.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.history.action === "POP") {
            var prevState = localStorage.getItem("suggestions-state");
            if (prevState) {
                var parsePrevState = JSON.parse(prevState);
                parsePrevState.dateFrom = moment(parsePrevState.dateFrom);
                parsePrevState.dateTo = moment(parsePrevState.dateTo);
                this.setState(tslib_1.__assign({}, parsePrevState, { page: this.props.history.location.search.split('=')[1] }), function () {
                    _this.getSuggestions();
                });
            }
            else {
                this.getSuggestions();
            }
        }
        else {
            this.getSuggestions();
        }
        localStorage.removeItem("suggestions-state");
    };
    Suggestions.prototype.componentWillUnmount = function () {
        console.log(this.state.dateFrom);
        localStorage.setItem("suggestions-state", JSON.stringify({
            filterRegions: this.state.filterRegions,
            filterSubthemes: this.state.filterSubthemes,
            filterThemes: this.state.filterThemes,
            filterRoles: this.state.filterRoles,
            filterStatuses: this.state.filterStatuses,
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            page: this.state.page,
            pageSize: this.state.pageSize,
            search_query: this.state.search_query,
            search_ids: this.state.search_ids,
        }));
    };
    Suggestions.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.history.action === "POP") {
            this.setState({ page: this.props.history.location.search.split('=')[1] }, function () {
                _this.getSuggestions();
            });
        }
    };
    Suggestions.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'id',
                width: 70,
                style: { textAlign: 'center' }
            }, {
                Header: 'Название',
                accessor: 'title',
            }, {
                Header: 'Описание',
                sortable: false,
                width: 300,
                accessor: 'description',
                Cell: function (props) {
                    return (React.createElement("span", { style: { whiteSpace: 'normal' } },
                        props.row._original.description.slice(0, 250),
                        props.row._original.description.length > 250 ? '...' : ''));
                }
            }, {
                Header: 'Статус',
                accessor: 'status',
                Cell: function (props) {
                    return (React.createElement("span", { className: "m-badge m-badge--wide " + (props.row._original.status === 'new' ? 'm-badge--info' : (props.row._original.status === 'approved' ? 'm-badge--success' : 'm-badge--danger')) }, props.row._original.status === 'new' ? 'На модерации' : (props.row._original.status === 'approved' ? 'Одобрено' : (props.row._original.status === 'declined' ? 'Отклонено' : 'Снято с публикации пользователем'))));
                }
            }, {
                Header: 'Подкатегория',
                accessor: 'subtheme_id',
                width: 50,
            }, {
                Header: 'Адрес',
                accessor: 'address',
            }, {
                Header: React.createElement("i", { className: "fa fa-thumbs-up" }),
                accessor: 'count_likes',
                width: 70,
            }, {
                Header: React.createElement("i", { className: "fa fa-comment-alt" }),
                accessor: 'count_comments',
                width: 70,
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    return (React.createElement("div", { className: "btn-group" },
                        props.row._original.status === 'new' && (React.createElement(React.Fragment, null,
                            React.createElement("button", { onClick: _this.changeStatus.bind(_this, props.row.id, 'approved'), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                                React.createElement("i", { className: "fa fa-thumbs-up" })),
                            React.createElement("button", { onClick: _this.changeStatus.bind(_this, props.row.id, 'declined'), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                                React.createElement("i", { className: "fa fa-thumbs-down" })))),
                        React.createElement(Link, { to: "/suggestions/" + props.row.id, className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-eye" })),
                        React.createElement("button", { onClick: _this.removeSuggestion.bind(_this, props.row.id), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-trash" }))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null, "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F"))),
            React.createElement("div", { className: 'admin-filters' },
                React.createElement("form", null,
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col col-xs-3' }, "ID"),
                        React.createElement("div", { className: 'col col-xs-3' }, "\u041F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E"),
                        React.createElement("div", { className: 'col col-xs-6' }, "\u041F\u043E \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0443 \u0434\u0430\u0442")),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col col-xs-3 pr-0' },
                            React.createElement("div", { className: 'form-group' },
                                React.createElement("input", { value: this.state.search_ids, type: 'text', onChange: function (e) { _this.setState({ search_ids: e.target.value }, _this.getSuggestions); }, className: 'form-control' }))),
                        React.createElement("div", { className: 'col col-xs-3' },
                            React.createElement("div", { className: 'form-group' },
                                React.createElement("input", { value: this.state.search_query, type: 'text', onChange: function (e) { _this.setState({ search_query: e.target.value }, _this.getSuggestions); }, className: 'form-control' }))),
                        React.createElement("div", { className: 'col col-xs-6' },
                            React.createElement(DateRangePicker, { startDate: this.state.dateFrom, endDate: this.state.dateTo, showDropdowns: true, maxDate: moment(), ranges: {
                                    'Сегодня': [
                                        moment(),
                                        moment(),
                                    ],
                                    'Вчера': [
                                        moment().subtract(1, 'days'),
                                        moment().subtract(1, 'days'),
                                    ],
                                    'Текущая неделя': [
                                        moment().startOf('week'),
                                        moment().startOf('week').add(7, 'days'),
                                    ],
                                    'Неделя': [
                                        moment().subtract(7, 'days'),
                                        moment(),
                                    ],
                                    'Последние 30 дней': [
                                        moment().subtract(30, 'days'),
                                        moment(),
                                    ],
                                    'Текущий месяц': [
                                        moment().startOf('month'),
                                        moment().endOf('month'),
                                    ],
                                    'Прошлый месяц': [
                                        moment().startOf('month').subtract(1, 'days').startOf('month'),
                                        moment().startOf('month').subtract(1, 'days').endOf('month'),
                                    ],
                                }, locale: {
                                    format: 'DD.MM.YYYY',
                                    customRangeLabel: 'Свой',
                                    separator: ' - ',
                                    applyLabel: 'Принять',
                                    cancelLabel: 'Отмена',
                                    fromLabel: 'С',
                                    toLabel: 'По',
                                    'weekLabel': 'Н',
                                    'daysOfWeek': [
                                        'Вс',
                                        'Пн',
                                        'Вт',
                                        'Ср',
                                        'Чт',
                                        'Пт',
                                        'Сб',
                                    ],
                                    'monthNames': [
                                        'Январь',
                                        'Февраль',
                                        'Март',
                                        'Апрель',
                                        'Май',
                                        'Июнь',
                                        'Июль',
                                        'Август',
                                        'Сентябрь',
                                        'Октябрь',
                                        'Ноябрь',
                                        'Декабрь',
                                    ],
                                    'firstDay': 1,
                                }, onApply: function (e, picker) {
                                    _this.setState({
                                        dateFrom: picker.startDate,
                                        dateTo: picker.endDate,
                                    }, function () { return _this.getSuggestions(); });
                                } },
                                React.createElement("div", { className: "row" },
                                    React.createElement("div", { className: 'col col-xs-6' },
                                        React.createElement("div", { style: { width: 'auto' }, className: 'admin-assessment__calendar-item' },
                                            React.createElement("div", { className: 'input-group date' },
                                                React.createElement("input", { type: 'text', value: this.state.dateFrom.format('D MMMM YYYY'), disabled: true, className: 'form-control pull-left' }),
                                                React.createElement("div", { className: 'input-group-addon' },
                                                    React.createElement("i", { className: 'fa fa-calendar' }))))),
                                    React.createElement("div", { className: 'col col-xs-6' },
                                        React.createElement("div", { style: { width: 'auto' }, className: 'admin-assessment__calendar-item' },
                                            React.createElement("div", { className: 'input-group date' },
                                                React.createElement("input", { type: 'text', value: this.state.dateTo.format('D MMMM YYYY'), disabled: true, className: 'form-control pull-left' }),
                                                React.createElement("div", { className: 'input-group-addon' },
                                                    React.createElement("i", { className: 'fa fa-calendar' }))))))))),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col col-xs-3' }, "\u0420\u0435\u0433\u0438\u043E\u043D"),
                        React.createElement("div", { className: 'col col-xs-3' }, "\u0422\u0435\u043C\u0430"),
                        React.createElement("div", { className: 'col col-xs-3' }, "\u041F\u043E\u0434\u0442\u0435\u043C\u0430"),
                        React.createElement("div", { className: 'col col-xs-3' }, "\u041E\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439")),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col col-xs-3' },
                            React.createElement("div", { className: 'form-group' },
                                React.createElement(Typeahead, { labelKey: "name", options: this.state.regionList, selected: this.state.filterRegions, multiple: true, onChange: function (filterRegions) {
                                        _this.setState({ filterRegions: filterRegions });
                                    } }))),
                        React.createElement("div", { className: 'col col-xs-3' },
                            React.createElement("div", { className: 'form-group' },
                                React.createElement(AsyncTypeahead, { isLoading: this.state.themeLoading, labelKey: "title", options: this.state.themeList, selected: this.state.filterThemes, multiple: false, onChange: function (filterThemes) {
                                        _this.setState({ filterThemes: filterThemes });
                                    }, onSearch: function (query) {
                                        _this.setState({ themeLoading: true });
                                        fetch(API_URL + "/themes?query=" + query)
                                            .then(function (resp) { return resp.json(); })
                                            .then(function (json) { return _this.setState({
                                            themeLoading: false,
                                            themeList: json.data,
                                        }, function () { return console.log(_this.state.themeList); }); });
                                    } }))),
                        React.createElement("div", { className: 'col col-xs-3' },
                            React.createElement("div", { className: 'form-group' },
                                React.createElement(AsyncTypeahead, { disabled: !(this.state.filterThemes[0] && this.state.filterThemes[0].id), isLoading: this.state.subthemeLoading, labelKey: "title", options: this.state.subthemeList, selected: this.state.filterSubthemes, multiple: true, onChange: function (filterSubthemes) {
                                        _this.setState({ filterSubthemes: filterSubthemes });
                                    }, onSearch: function (query) {
                                        _this.setState({ subthemeLoading: true });
                                        fetch(API_URL + "/subthemes/" + _this.state.filterThemes[0].id + "?query=" + query)
                                            .then(function (resp) { return resp.json(); })
                                            .then(function (json) { return _this.setState({
                                            subthemeLoading: false,
                                            subthemeList: json.data,
                                        }); });
                                    } }))),
                        React.createElement("div", { className: 'col col-xs-3' },
                            React.createElement("div", { className: 'form-group' },
                                React.createElement(Typeahead, { labelKey: "name", options: this.state.rolesList, selected: this.state.filterRoles, multiple: true, onChange: function (filterRoles) {
                                        _this.setState({ filterRoles: filterRoles });
                                    } })))),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col col-xs-3' }, "\u0421\u0442\u0430\u0442\u0443\u0441")),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col col-xs-3' },
                            React.createElement("div", { className: 'form-group' },
                                React.createElement(Typeahead, { labelKey: "name", options: this.state.statusList, selected: this.state.filterStatuses, multiple: true, onChange: function (filterStatuses) {
                                        _this.setState({ filterStatuses: filterStatuses });
                                    } })))),
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col col-xs-2 text-right' },
                            React.createElement("button", { onClick: this.getReport.bind(this), type: 'button', disabled: this.state.report, className: 'btn btn-success btn-search ' + (this.state.report ? 'disabled' : '') }, this.state.report ? 'Ожидайте...' : 'Выгрузить EXCEL')),
                        React.createElement("div", { className: 'col col-md-1 text-right' },
                            React.createElement("button", { onClick: this.getSuggestions.bind(this), type: 'button', className: 'btn btn-primary btn-search' }, "\u041D\u0410\u0419\u0422\u0418"))))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: 'Loading...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.suggestions, columns: columns })))));
    };
    Suggestions.prototype.getSuggestions = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&sort=' + this.state.sort + '&limit=' + this.state.pageSize;
        var regArr = [];
        this.state.filterRegions.forEach(function (fr) {
            regArr.push(fr.guid);
        });
        var regTh = [];
        this.state.filterThemes.forEach(function (ft) {
            regTh.push(ft.id);
        });
        searchString += '&tids=' + regTh.join(",");
        var regSub = [];
        this.state.filterSubthemes.forEach(function (fs) {
            regSub.push(fs.id);
        });
        searchString += '&sids=' + regSub.join(",");
        var rolesArr = [];
        this.state.filterRoles.forEach(function (fr) {
            rolesArr.push(fr.value);
        });
        if (rolesArr.length > 0) {
            searchString += '&uroles=' + rolesArr.join(",");
        }
        var statusesArr = [];
        this.state.filterStatuses.forEach(function (fs) {
            statusesArr.push(fs.value);
        });
        if (statusesArr.length > 0) {
            searchString += '&sstatuses=' + statusesArr.join(",");
        }
        searchString += '&query=' + this.state.search_query + '&ids=' + this.state.search_ids + '&regions=' + regArr.join(",");
        searchString += "&dfrom=" + this.state.dateFrom.format('YYYY-MM-DD') + "&dto=" + this.state.dateTo.format('YYYY-MM-DD');
        axios.get(API_URL + '/suggestion?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                suggestions: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    Suggestions.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () {
            _this.getSuggestions();
            _this.addParamToUrl(page + 1);
        });
    };
    Suggestions.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getSuggestions(); });
    };
    Suggestions.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getSuggestions();
            _this.addParamToUrl(_this.state.page + 1);
        });
    };
    Suggestions.prototype.removeSuggestion = function (id) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите удалить предложение?');
        if (result) {
            axios.delete(API_URL + '/suggestion/' + id, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getSuggestions();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    Suggestions.prototype.changeStatus = function (id, status) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите изменить статус предложения?');
        if (result) {
            axios.post(API_URL + '/suggestion/change-status/' + id, qs.stringify({
                status: status,
            }), {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getSuggestions();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    Suggestions.prototype.addParamToUrl = function (param) {
        var url = '?page=' + param;
        this.props.history.push(url);
        return true;
    };
    Suggestions.prototype.getReport = function () {
        var _this = this;
        var thisThis = this;
        this.setState({
            report: true,
        }, function () {
            var searchString = '';
            var regArr = [];
            _this.state.filterRegions.forEach(function (fr) {
                regArr.push(fr.guid);
            });
            var regTh = [];
            _this.state.filterThemes.forEach(function (ft) {
                regTh.push(ft.id);
            });
            searchString += '&tids=' + regTh.join(",");
            var regSub = [];
            _this.state.filterSubthemes.forEach(function (fs) {
                regSub.push(fs.id);
            });
            searchString += '&sids=' + regSub.join(",");
            var rolesArr = [];
            _this.state.filterRoles.forEach(function (fr) {
                rolesArr.push(fr.value);
            });
            if (rolesArr.length > 0) {
                searchString += '&uroles=' + rolesArr.join(",");
            }
            var statusesArr = [];
            _this.state.filterStatuses.forEach(function (fs) {
                statusesArr.push(fs.value);
            });
            if (statusesArr.length > 0) {
                searchString += '&sstatuses=' + statusesArr.join(",");
            }
            searchString += '&query=' + _this.state.search_query + '&ids=' + _this.state.search_ids + '&regions=' + regArr.join(",");
            searchString += "&dfrom=" + _this.state.dateFrom.format('YYYY-MM-DD') + "&dto=" + _this.state.dateTo.format('YYYY-MM-DD');
            axios.get(API_URL + '/suggestion/excel?token=' + _this.props.auth_token + '&' + searchString)
                .then(function (r) {
                if (r.data.code === 200) {
                    // @ts-ignore
                    function f() {
                        return tslib_1.__awaiter(this, void 0, void 0, function () {
                            var _loop_1, state_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _loop_1 = function () {
                                            var complete;
                                            return tslib_1.__generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, thisThis.sleep(10000)];
                                                    case 1:
                                                        _a.sent();
                                                        complete = false;
                                                        axios.get(API_URL + '/' + r.data.text + '&token=' + thisThis.props.auth_token).then(function (res) {
                                                            if (res.data.code === 201) {
                                                                complete = true;
                                                                thisThis.setState({
                                                                    report: false,
                                                                });
                                                                window.open(API_URL + '/' + res.data.text + '&token=' + thisThis.props.auth_token);
                                                            }
                                                        }).catch(function (err) {
                                                            console.log(err);
                                                            complete = true;
                                                            thisThis.setState({
                                                                report: false,
                                                            }, function () {
                                                                alert('Не удалось сформировать выгрузку');
                                                            });
                                                        });
                                                        return [4 /*yield*/, thisThis.sleep(1000)];
                                                    case 2:
                                                        _a.sent();
                                                        if (complete) {
                                                            return [2 /*return*/, "break-labelCancelWhile"];
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        };
                                        _a.label = 1;
                                    case 1:
                                        if (!true) return [3 /*break*/, 3];
                                        return [5 /*yield**/, _loop_1()];
                                    case 2:
                                        state_1 = _a.sent();
                                        switch (state_1) {
                                            case "break-labelCancelWhile": return [3 /*break*/, 3];
                                        }
                                        return [3 /*break*/, 1];
                                    case 3:
                                        ;
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                    f();
                }
            }).catch(function (e) {
                console.log(e);
                _this.setState({
                    report: false,
                }, function () {
                    alert('Не удалось сформировать выгрузку');
                });
            });
        });
    };
    Suggestions.prototype.sleep = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    return Suggestions;
}(React.Component));
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(Suggestions));



//////////////////
// WEBPACK FOOTER
// ./src/views/suggestions/index.tsx
// module id = 326
// module chunks = 0